import { replace } from 'react-router-redux';

export default function redirectOnHash(store) {
  const hash = window.location.hash;

  if (hash.indexOf('#!') !== 0) {
    return;
  }

  const route = hash.slice(2);
  store.dispatch(replace(route));
}



// WEBPACK FOOTER //
// ./src/utils/location.js